import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import { getUserInfo } from '../../../../../crud/orgs.crud'

/**
 * Loads the company access and permission mappings a system user's edit form starts from.
 * Nothing loads while `enabled` is false.
 */
const useSystemUserInfo = ({ organizationId, userId, enabled = true }) => {
  const [userInfo, setUserInfo] = useState(null)
  const [isLoading, setLoading] = useState(enabled)
  const [hasLoadError, setLoadError] = useState(false)

  useEffect(() => {
    if (!enabled) return undefined
    let isCurrent = true

    const load = async () => {
      setLoading(true)
      setLoadError(false)
      try {
        const { data } = await getUserInfo(organizationId, userId)
        if (isCurrent) setUserInfo(isEmpty(data) ? null : data)
      } catch (error) {
        console.error('Error loading user data', error)
        if (isCurrent) setLoadError(true)
      } finally {
        if (isCurrent) setLoading(false)
      }
    }
    load()

    return () => {
      isCurrent = false
    }
  }, [enabled, organizationId, userId])

  return { userInfo, isLoading, hasLoadError }
}

export default useSystemUserInfo
